import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "q-px-sm" }

import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import BaseModal from '../wrappers/BaseModal.vue'
import { useModelWrapper } from '../wrappers/helpers/useModelWrapper'
import { useCodes } from '../../store/useCodes'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormBulkUpdateRai',
  props: {
    modelValue: { type: Boolean },
    checkedTaskIds: {}
  },
  emits: ["setBulkRaiFilter", "update:modelValue", "updateRaiCode"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
/**Controls if popup shows or not */
const value = useModelWrapper(props, emit)
const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`form.${key}`)
const close = () => {
  // Close the modal
  value.value = false
}
const update = async () => {
  if (await valid()) {
    emit('updateRaiCode', { rai_code: selection.value, rai_reason_code: reasonSelection.value })
    // Close modal
    value.value = false
  }
}
const selection = ref()
const selectionRef = ref()
/** Updates selection and clears stale reason selection */
const updateSelection = (val: any) => {
  reasonSelection.value = undefined
  selection.value = val
}
const { bulkUpdateRaiCodes: options } = storeToRefs(useCodes())
const { getReasonCodesByRaiCodeId, isRaiApplicableForTask } = useCodes()
const reasonSelection = ref()
const reasonSelectionRef = ref()
const reasonOptions = computed(() => {
  if (!selection.value) return []
  else {
    return getReasonCodesByRaiCodeId(selection.value.id)
  }
})

/**
 * Run quasar's validation and return if conditions are met
 */
const valid = async () => {
  let selValid = true
  let reasValid = true
  //run validations
  if (selectionRef.value) {
    selValid = await selectionRef.value.validate()
  }
  if (reasonSelectionRef.value) {
    reasValid = await reasonSelectionRef.value.validate()
  }
  //if a reason code selection, check its valid, otherwise just check if rai code selection valid
  if (reasonSelectionRef.value) {
    return selValid && reasValid
  }
  return selValid
}

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(BaseModal, {
    modelValue: _unref(value),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(label('bulkUpdateRai')), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", null, [
        _createTextVNode(_toDisplayString(label('bulkUpdateRaiNote')) + " ", 1),
        _createElementVNode("a", {
          class: "text-primary underline cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('setBulkRaiFilter')))
        }, _toDisplayString(label('bulkUpdateRaiFilter')), 1)
      ]),
      _createVNode(_component_q_select, {
        filled: "",
        ref_key: "selectionRef",
        ref: selectionRef,
        "model-value": selection.value,
        "onUpdate:modelValue": updateSelection,
        options: _unref(options),
        rules: [
          (val) => val || label('requiredGeneric'),
          (val) => _ctx.checkedTaskIds.every(id => _unref(isRaiApplicableForTask)(val.code, String(id))) || label('bulkUpdateRaiNotApplicable')
        ],
        color: "accent",
        label: "RAI Code",
        behavior: "menu"
      }, null, 8, ["model-value", "options", "rules"]),
      (reasonOptions.value.length)
        ? (_openBlock(), _createBlock(_component_q_select, {
            key: 0,
            filled: "",
            ref_key: "reasonSelectionRef",
            ref: reasonSelectionRef,
            modelValue: reasonSelection.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((reasonSelection).value = $event)),
            options: reasonOptions.value,
            rules: [(val) => val || label('requiredGeneric')],
            color: "accent",
            label: "RAI Reason Code",
            behavior: "menu"
          }, null, 8, ["modelValue", "options", "rules"]))
        : _createCommentVNode("", true)
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_q_btn, {
        rounded: "",
        flat: "",
        onClick: close,
        label: label('close')
      }, null, 8, ["label"]),
      _createVNode(_component_q_btn, {
        rounded: "",
        color: "primary",
        onClick: update
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(label('update')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})